module.exports = __webpack_public_path__ + "img/icn-kehu.9abd0755.png";